import * as Yup from "yup";
export var resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .required("Senha é obrigatória")
        .matches(RegExp("(?=.*?[a-z])(?=.*?[0-9])"), "Sua senha deve conter letras e números")
        .matches(RegExp("(?=.{8,}$)"), "Mínimo de 8 caracteres")
        .matches(RegExp("(?=.*?[A-Z])"), "1 caractere maiúsculo")
        .matches(RegExp("(?=.*?[a-z])"), "1 caractere minúsculo")
        .matches(RegExp(/(?=.*[¨()+={}[\]^\\|$*&@#!%:;~`´?'"><,.-/-_])/), "1 caractere especial"),
    password_confirmation: Yup.string().required("Campo obrigatório"),
});
